import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ThreeColumnText}
 */

const ThreeColumnText = ({
    heading,
    col1Heading,
    col1Body,
    col2Heading,
    col2Body,
    col3Heading,
    col3Body
}) => {

    const hasFirstCol = !!(col1Heading || col1Body);

    return (
        <div className='module-three-column-text theme-light bg-main-background py-24 sm:py-40 md:py-32'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper flex flex-col sm:flex-row md:flex-col md:gap-32'>
                    {/* Heading Section - shown on mobile/tablet, or on desktop when hasFirstCol is true */}
                    {heading && hasFirstCol && (
                        <div className='md:mb-32 mb-16 col-padding sm:w-6/12 md:w-full'>
                            <h2 className='type-style-2 sm:pr-40 md:pr-0'>
                                {heading}
                            </h2>
                        </div>
                    )}
                    {heading && !hasFirstCol && (
                        <div className='md:mb-32 mb-16 col-padding sm:w-6/12 md:w-full md:hidden'>
                            <h2 className='type-style-2 sm:pr-40 md:pr-0'>
                                {heading}
                            </h2>
                        </div>
                    )}
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-y-16 sm:w-6/12 md:w-full'>
                        {/* Column 1 */}
                        {hasFirstCol && (
                            <div className='flex flex-col gap-12 col-padding md:border-r md:border-main-border'>
                                {col1Heading && (
                                    <h3 className='type-style-3'>
                                        {col1Heading}
                                    </h3>
                                )}
                                {col1Body && (
                                    <p className='type-style-body'>
                                        {col1Body}
                                    </p>
                                )}
                            </div>
                        )}
                        {!hasFirstCol && heading && (
                            <div className='hidden md:flex flex-col gap-12 col-padding md:border-r md:border-main-border'>
                                <h2 className='type-style-2'>
                                    {heading}
                                </h2>
                            </div>
                        )}

                        {/* Column 2 */}
                        {(col2Heading || col2Body) && (
                            <div className='flex flex-col gap-12 col-padding md:border-r md:border-main-border'>
                                {col2Heading && (
                                    <h3 className='type-style-3'>
                                        {col2Heading}
                                    </h3>
                                )}
                                {col2Body && (
                                    <p className='type-style-body'>
                                        {col2Body}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Column 3 */}
                        {(col3Heading || col3Body) && (
                            <div className='flex flex-col gap-12 col-padding'>
                                {col3Heading && (
                                    <h3 className='type-style-3'>
                                        {col3Heading}
                                    </h3>
                                )}
                                {col3Body && (
                                    <p className='type-style-body'>
                                        {col3Body}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ThreeColumnText;
